import { Box, Skeleton } from '@mui/material';
import { ReactElement } from 'react';
import { minMaxRand } from 'shared/utils/number';

export function DocumentationBrowserSkeleton(): ReactElement {
  const rows = Array.from({ length: 7 });

  return (
    <Box sx={{ height: 240, overflowY: 'hidden' }}>
      {rows.map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            height: 40,
            pl: 2,
          }}
        >
          <Skeleton variant='rectangular' width='24px' height='24px' />
          <Skeleton
            variant='rectangular'
            width={`${minMaxRand(36, 80)}%`}
            height='24px'
          />
        </Box>
      ))}
    </Box>
  );
}
